<template>
    <div>
        <div
            v-if="!date"
            class="flex flex-col gap-2 text-left font-medium 2xl:gap-0.5"
            :class="$props.textRight ? 'md:items-end' : 'md:items-start'"
        >
            <span class="text-xs leading-none 2xl:text-sm">
                {{ header }}
            </span>
            <span class="min-w-[45px] text-xs leading-none text-[#9B9B9B] empty:hidden 2xl:min-w-0">
                {{ description }}
            </span>
        </div>
        <div
            v-else
            class="flex flex-row gap-2 text-left font-medium 2xl:flex-col 2xl:gap-0.5"
            :class="$props.textRight ? '2xl:items-end' : '2xl:items-start'"
        >
            <span class="order-2 text-xs leading-none 2xl:order-1 2xl:text-sm">
                {{ header }}
            </span>
            <span class="order-1 min-w-[45px] text-xs leading-none text-[#9B9B9B] empty:hidden 2xl:order-2 2xl:min-w-0">
                {{ description }}
            </span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    header: {
        type: String,
        required: true,
    },
    description: {
        type: String,
        required: true,
    },
    date: {
        type: Boolean,
        required: false,
    },
    textRight: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>
